import { FaceBook, Twitter } from '@carvana/icons';
import createComponent from '@carvana/merch-components/createComponent';

export const Wrapper = createComponent('div', {
  className:
    'mb-40 flex flex-col items-center gap-12 m:mb-[100px] m:flex-row m:justify-center'
});

export const FacebookIcon = createComponent(FaceBook, {
  className: 'flex items-center'
});

export const TwitterIcon = createComponent(Twitter, {
  className: 'flex items-center'
});

const Button = createComponent('button', {
  className:
    'flex h-[56px] w-[256px] items-center justify-center gap-20 rounded-sm text-white tl-label-m'
});

export const FacebookButton = createComponent(Button, {
  className: 'bg-[#3c5a99]'
});

export const TwitterIntegrationButton = createComponent(Button, {
  className: 'bg-[#00acee]'
});

export const ExploreButton = createComponent(Button, {
  className: 'bg-blue-2'
});
